<template>
  <BusinessList
    :tabPanelData="tabList"
    :pageTypeIn="'ORDER'"
    permission="TO_ORDERED_BUSINESS"
    :canCommand="false"
    :marketFeeCanCommand="false"
    :FilterFieldProps="FilterField"
    businessTypeName="TABLE_TO_ORDERED_BUSINESS"
    :HiddenFieldFunProps="(item:any) => '订单号码、内部订单号、发票号码、发票金额、预计完成天数、开票状态、开票日期、收款状态、收款日期'.split('、').some(fieldName => fieldName === item.fieldName)"
  />
</template>
<script lang="ts">
import { defineComponent, reactive, toRefs } from 'vue'
import BusinessList from '@/views/business/businessList/components/BusinessTable.vue'
import { FilterField } from './FilterField'

export default defineComponent({
  name: 'Toorderedbusiness',
  components: {
    BusinessList
  },
  setup() {
    const dataMap = reactive({
      tabList: [
        {
          name: '联系人',
          id: 1
        }
        // {
        //   name: '市场费',
        //   id: 4
        // },
        // {
        //   name: '工程师',
        //   id: 2
        // },
        // {
        //   name: '跟踪信息',
        //   id: 3
        // }
      ],
      FilterField
    })
    return { ...toRefs(dataMap) }
  }
})
</script>
